import type { SyncStatus } from '@vy/types';
import { SYNC_STATUSES } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';
import React from 'react';
import { FailedIcon } from './invoice-sync-status-label-icons/FailedIcon';
import { SyncedIcon } from './invoice-sync-status-label-icons/SyncedIcon';
import { VyTooltip } from '../../../../../components/new-design/VyTooltip';

type InvoiceSyncStatusLabelProps = {
  syncStatus: SyncStatus;
  syncStatusUpdatedAt: string;
  className?: string;
};

export const InvoiceSyncStatusLabel: React.FC<InvoiceSyncStatusLabelProps> = ({
  syncStatus,
  syncStatusUpdatedAt,
  className,
}) => {
  return <div className={className}>{getSyncStatusIcon(syncStatus, syncStatusUpdatedAt)}</div>;
};

export function getSyncStatusIcon(syncStatus: SyncStatus, syncStatusUpdatedAt: string) {
  switch (syncStatus) {
    case SYNC_STATUSES.None:
      return <span />;
    case SYNC_STATUSES.Synced:
      return (
        <VyTooltip tooltipContent={`Synced on ${syncStatusUpdatedAt}`} placement="top">
          <div>
            <SyncedIcon className="h-4.5 w-4.5" />
          </div>
        </VyTooltip>
      );
    case SYNC_STATUSES.Failed:
      return (
        <VyTooltip tooltipContent={`Failed syncing on ${syncStatusUpdatedAt}`} placement="top">
          <div>
            <FailedIcon className="h-4.5 w-4.5" />
          </div>
        </VyTooltip>
      );
    default:
      return raiseUnreachable(syncStatus);
  }
}
